import http from "@/components/common/tui-request";

let baseUrl = "";

if (process.env.NODE_ENV === "development") {
  // baseUrl = "http://hxzd.tongchealth.com/basic-api";
  // baseUrl = "https://test.chendimao.com/basic-api3/basic-api/";
  baseUrl = "http://192.168.0.11:50021";

} else {
  // baseUrl = "https://test.chendimao.com/basic-api3/basic-api/";
  baseUrl = "/basic-api";
}

//初始化请求配置项
http.create({
  host: baseUrl,

  header: {
    "content-type": "application/json",
  },
});

//请求拦截
http.interceptors.request.use((config) => {
  config.concise = true;

  // let token = uni.getStorageSync('thorui_token');
  // if (config.header) {
  //     config.header['Authorization'] = token
  // } else {
  //     config.header = {
  //         'Authorization': token
  //     }
  // }
  return config;
});

//响应拦截
http.interceptors.response.use((response) => {
  //TODO
  return response;
});
http.baseUrl = baseUrl;
// #ifdef VUE3
export default http;
// #endif
